import { AlertTriangle } from "lucide-react";
import SEO from "@/components/SEO";
import { CONTACT } from "@/data/services";

export const LegalNotice = () => (
  <div
    className="bg-amber-50 border border-amber-300 rounded-xl p-5 flex items-start gap-3 text-sm text-amber-900"
    role="alert"
    data-testid="legal-placeholder-warning"
  >
    <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" aria-hidden="true" />
    <div>
      <strong>Platzhalter – vor dem Livegang ersetzen:</strong> Diese Seite enthält einen unverbindlichen Entwurf. Die
      Texte müssen vor Veröffentlichung rechtlich geprüft und vervollständigt werden (z. B. IHK-Muster,
      Impressums-Generator oder Anwalt). Angaben ohne Gewähr.
    </div>
  </div>
);

export default function Impressum() {
  return (
    <>
      <SEO
        title="Impressum | ZWILLINGSWERK Herten"
        description="Impressum von ZWILLINGSWERK, Garten- & Hausmeisterservice, Johannesstraße 20, 45701 Herten."
      />
      <section className="py-16 bg-[#F8FAF8]" data-testid="impressum-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <h1 className="text-3xl sm:text-4xl font-black text-[#122B18] font-display">Impressum</h1>
          <LegalNotice />

          <div className="bg-white border border-[#D7E5D9] rounded-xl p-6 space-y-6 text-sm text-[#4A634E] leading-relaxed">
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">Angaben gemäß § 5 TMG / DDG</h2>
              <p>
                ZWILLINGSWERK – Garten- &amp; Hausmeisterservice
                <br />
                {CONTACT.street}
                <br />
                {CONTACT.city}
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">Kontakt</h2>
              <p>
                Telefon: {CONTACT.phoneDisplay}
                <br />
                E-Mail: {CONTACT.email}
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">Vertretungsberechtigt</h2>
              <p>[Platzhalter: Namen der Inhaber / Geschäftsführer ergänzen]</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">Umsatzsteuer</h2>
              <p>[Platzhalter: Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG ergänzen]</p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">Verantwortlich für den Inhalt</h2>
              <p>[Platzhalter: Verantwortliche Person nach § 18 Abs. 2 MStV ergänzen]</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
